import React from 'react';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {addUrl} from "../histori/HistoriSlice";



function Navbar({ curTeam, toggleTeam ,currpage}) {
    const [isOpen, setIsOpen] = useState(false);
    const ChooseBar = () => {
        if(currpage == "mainpage")
        {
            return(<MainNavLinks curTeam={curTeam} toggleTeam={toggleTeam} />);
        }
        else if (currpage == "singlepokemonWinchance")
        {
            return (<WinchanceNavLinks/>);
        }
        else if (currpage == "historypage")
        {
            return (<HistoryNavLinks/>);
        }
        else if (currpage == "Team")
        {
            return (<TeamWinNavLinks/>);
        }
    };
    return (
        <nav className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center space-x-4">
                        <span className="text-xl font-bold tracking-wide">Find your Pokemon</span>
                    </div>
                    <div>
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white focus:outline-none"
                        >
                            <Menu className="w-6 h-6" />
                        </button>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="px-4 pb-4 space-y-2">
                    <ChooseBar/>
                </div>
            )}
        </nav>
    );
}


function MainNavLinks({ curTeam, toggleTeam, mobile = true }) {
    const baseStyle = "block px-4 py-2 rounded hover:bg-white hover:text-indigo-600 transition font-medium";
    return (
        <>
            <Link to="/pokemons/History">
                <span className={baseStyle}>Historie</span>
            </Link>
            <Link to="/pokemons/Calc">
                <span className={baseStyle}>WinChance Calculator</span>
            </Link>
            <Link to="/pokemons/TeamWinCal">
                <span className={baseStyle}>Team Winchance Calculator</span>
            </Link>
            <Link to={`/pokemons/${localStorage.getItem(1)}`}>
                <span className={baseStyle}>Preview {curTeam}</span>
            </Link>
            <span onClick={toggleTeam} className={baseStyle}>



                Přepnout tým ({curTeam})
            </span>

        </>
    );

};
function WinchanceNavLinks({ mobile = true }) {
    const baseStyle = "block px-4 py-2 rounded hover:bg-white hover:text-indigo-600 transition font-medium";
    return (
        <>
            <Link to="/pokemons/History">
                <span className={baseStyle}>Historie</span>
            </Link>
            <Link to="/pokemons">
                <span className={baseStyle}>vyhledavač</span>
            </Link>
            <Link to="/pokemons/TeamWinCal">
                <span className={baseStyle}>Team Winchance Calculator</span>
            </Link>


        </>
    );

};
function HistoryNavLinks({ mobile = true }) {
    const baseStyle = "block px-4 py-2 rounded hover:bg-white hover:text-indigo-600 transition font-medium";
    return (
        <>
            <Link to="/pokemons/Calc">
                <span className={baseStyle}>WinChance Calculator</span>
            </Link>
            <Link to="/pokemons">
                <span className={baseStyle}>vyhledavač</span>
            </Link>
            <Link to="/pokemons/TeamWinCal">
                <span className={baseStyle}>Team Winchance Calculator</span>
            </Link>


        </>
    );

};
function TeamWinNavLinks({ mobile = true }) {
    const baseStyle = "block px-4 py-2 rounded hover:bg-white hover:text-indigo-600 transition font-medium";
    return (
        <>
            <Link to="/pokemons/Calc">
                <span className={baseStyle}>WinChance Calculator</span>
            </Link>
            <Link to="/pokemons">
                <span className={baseStyle}>vyhledavač</span>
            </Link>
            <Link to="/pokemons/TeamWinCal">
                <span className={baseStyle}>Team Winchance Calculator</span>
            </Link>


        </>
    );

};


export default Navbar;